






import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
    name: 'control-validator-group'
})

export default class ControlValidatorGroupComponent extends Vue {   
    isValidChilds(vue: Vue, isValid: boolean): boolean {        
        vue.$children.forEach(element => {
            if((element as any).isValid){
                var validate = (element as any).isValid();                    
                isValid = isValid && validate;
            } else if ((element as Vue).$children.length > 0) {
                isValid = this.isValidChilds(element, isValid);
            }
        });
        return isValid;
    }
    isValid(): boolean {
        return this.isValidChilds(this as Vue, true);
    }

    clearValidChilds(vue: Vue) {
      vue.$children.forEach(element => {
            if ((element as any).clearValid) {
                (element as any).clearValid();  
            } 
            else if ((element as Vue).$children.length > 0) {
                this.clearValidChilds(element);
            }
        });
    }
    clearValid(): void {
        this.clearValidChilds(this as Vue);
    }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/components/control-validator-group.vue